if (!customElements.get('cart-bundle-upsell')) {
	customElements.define('cart-bundle-upsell', class CartBundleUpsell extends HTMLElement {
		connectedCallback() {
			this.select = this.querySelector('[data-bundle-variant]');
			this.button = this.querySelector('[data-bundle-add]');
			this.image = this.querySelector('[data-bundle-image]');
			this.message = this.querySelector('[data-bundle-message]');
			this.select?.addEventListener('change', this.updateSelection);
			this.button?.addEventListener('click', this.addItem);
			this.updateIntentMessage();
			this.updateSelection();
		}

		disconnectedCallback() {
			this.select?.removeEventListener('change', this.updateSelection);
			this.button?.removeEventListener('click', this.addItem);
		}

		updateIntentMessage() {
			let target = 1;
			try { target = Number(sessionStorage.getItem('svytBundleTarget') || 1); } catch (error) {}
			const count = Number(this.dataset.cartCount);
			if (target > 1 && target <= count) {
				try { sessionStorage.setItem('svytBundleTarget', '1'); } catch (error) {}
				return;
			}
			if (target > 1) this.dataset.bundleTarget = String(target);
		}

		updateSelection = () => {
			const option = this.select?.selectedOptions[0];
			if (!option) return;
			if (this.image && option.dataset.image) this.image.src = option.dataset.image;
			const nextCount = Number(this.dataset.cartCount) + 1;
			const discount = nextCount >= 3 ? Number(this.dataset.threeDiscount) : Number(this.dataset.twoDiscount);
			const previewPrice = Math.round(Number(option.dataset.price) * (100 - discount) / 100);
			const label = this.querySelector('[data-bundle-add-label]');
			if (label) label.textContent = this.dataset.addTemplate.replace('__PRICE__', formatMoney(previewPrice));
			this.updateSavingsMessage(Number(option.dataset.price));
		};

		updateSavingsMessage(optionPrice) {
			const count = Number(this.dataset.cartCount);
			const subtotal = Number(this.dataset.cartSubtotal);
			const status = this.querySelector('[data-bundle-status]');
			if (!status) return;
			if (count >= 3) {
				const savings = Math.round(subtotal * Number(this.dataset.threeDiscount) / 100);
				status.textContent = `● ${this.dataset.levelReached.replace('__AMOUNT__', formatMoney(savings))}`;
				return;
			}
			const requestedTarget = Number(this.dataset.bundleTarget || 1);
			const target = requestedTarget > count ? requestedTarget : count + 1;
			const remaining = target - count;
			const discount = target >= 3 ? Number(this.dataset.threeDiscount) : Number(this.dataset.twoDiscount);
			const projectedSubtotal = subtotal + optionPrice * remaining;
			const savings = Math.round(projectedSubtotal * discount / 100);
			const template = target === 2 ? this.dataset.intentTwo : remaining === 1 ? this.dataset.intentThreeOne : this.dataset.intentThreeTwo;
			status.textContent = template.replace('__AMOUNT__', formatMoney(savings));
		}

		addItem = async () => {
			if (this.isSubmitting || !this.select?.value) return;
			const cart = document.querySelector('cart-drawer');
			this.isSubmitting = true;
			this.button.setAttribute('aria-disabled', 'true');
			this.button.classList.add('loading');
			this.button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
			this.message.hidden = true;

			const body = { items: [{ id: Number(this.select.value), quantity: 1 }] };
			if (cart) {
				body.sections = cart.getSectionsToRender().map((section) => section.id);
				body.sections_url = window.location.pathname;
				cart.setActiveElement(document.activeElement);
			}

			try {
				const response = await fetch(routes.cart_add_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
					body: JSON.stringify(body)
				});
				const result = await response.json();
				if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.addError);
				result.id = Number(this.select.value);
				document.dispatchEvent(new CustomEvent('cart:change', { detail: result, bubbles: true }));
				if (cart) cart.renderContents(result);
				else window.location = window.routes.cart_url;
			} catch (error) {
				this.message.textContent = error.message;
				this.message.hidden = false;
				this.isSubmitting = false;
				this.button.removeAttribute('aria-disabled');
				this.button.classList.remove('loading');
				this.button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
			}
		};
	});
}
